import React, { Component } from 'react';
import styles from './index.module.scss';
import mainLogo from '../../images/uae/da_learning.png';
import footer from '../../images/uae/footer.png';
import title from '../../images/uae/title.svg';
import subtitle from '../../images/uae/subtitle.svg';
import nextBtn from '../../images/uae/nextBtn.svg';

export function pixelsToVW(pixels, designWidth = 1080) {
  return (pixels / designWidth) * 100 + 'vw';
}

export function pixelsToVH(pixels, designWidth = 1920) {
  return (pixels / designWidth) * 100 + 'vh';
}

class EntryPage extends Component {
  constructor(props) {
    super(props);
    this.updateState = props.updateState;
    this.OnGenerate = props.OnGenerate;
    this.state = {
      imageBase64: '',
      progress: 0,
    };
  }

  render() {
    return (
      <div
        className={styles.entryPage}
        style={{
          padding: `1vh ${pixelsToVW(80)}`,
          boxSizing: 'border-box',
        }}
      >
        <header className={styles.header}>
          <img
            src={mainLogo}
            alt='Logo'
            className={styles.logo}
            style={{
              height: pixelsToVH(264.56),
              width: 'auto',
            }}
          />
        </header>

        <main className={styles.mainContent}>
          <div className={styles.textContainer}>
            <img
              src={title}
              alt='title'
              style={{
                width: pixelsToVW(626.43),
                height: 'auto',
              }}
            />
          </div>
          <div
            className={styles.infoText}
            style={{
              marginTop: pixelsToVH(60),
            }}
          >
            <img
              src={subtitle}
              alt='subtitle'
              style={{
                width: pixelsToVW(805.02),
                height: 'auto',
              }}
            />
          </div>
          <div
            // className={styles.nextButton}
            onClick={() => {
              this.updateState(0);
              this.OnGenerate();
            }}
            style={{
              marginTop: pixelsToVH(62),
              width: pixelsToVW(311.486),
              height: pixelsToVH(92.292),
              display: 'flex',
              alignItems: 'flex-start',
              zIndex: 1,
            }}
          >
            <img
              src={nextBtn}
              alt='next'
              style={{
                height: '100%',
              }}
            />
          </div>
        </main>

        <footer
          className={styles.footer}
          style={{
            height: pixelsToVH(600),
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'flex-end',
            width: '100%'
          }}
        >
          <img
            src={footer}
            alt='fotter'
            style={{ height: '100%', objectFit: 'contain' }}
            loading='lazy'
          />
        </footer>
      </div>
    );
  }
}

export default EntryPage;
